import { Award, Crown, Shield, Sparkles, TrendingUp } from "lucide-react"

import { cn } from "@/lib/utils"

// The freelancer tier ladder (Premium › Top › Urban › Rising › New). Calm, not
// rainbow: rank reads as DEPTH on a monochrome ramp (Premium darkest standout →
// New lightest), each tier carrying a Lucide glyph — only Premium is the bold
// near-black chip. Color stays reserved for real signal (the red CTA, online
// presence). Light + dark ramps mirror design/spec/shared/freelancers.css.
const TIER = {
  Premium: {
    Icon: Crown,
    cls: "bg-[#232321] text-white dark:bg-[#E1E1E1] dark:text-[#1F1F1F]",
  },
  Top: {
    Icon: Award,
    cls: "bg-[#46453F] text-white dark:bg-[#BEBEBE] dark:text-[#1F1F1F]",
  },
  Urban: {
    Icon: Shield,
    cls: "bg-[#5E5C54] text-white dark:bg-[#7D7D7D] dark:text-white",
  },
  Rising: {
    Icon: TrendingUp,
    cls: "bg-[#76746B] text-white dark:bg-[#4A4A4A] dark:text-[#E1E1E1]",
  },
  New: {
    Icon: Sparkles,
    cls: "bg-[#E9E8E3] text-[#5C5A52] dark:bg-[#303030] dark:text-[#969696]",
  },
}

export default function TierBadge({ tier, className }) {
  // Non-writer roster roles carry no customer-facing ladder tier (the presenter
  // emits `tier: null` for them — AQ-014, decision 5). Suppress the badge rather
  // than falling back to a blank "New"-styled chip with a dangling empty label.
  if (!tier || !TIER[tier]) return null

  const meta = TIER[tier]
  const { Icon } = meta

  return (
    <span
      className={cn(
        "inline-flex items-center gap-[5px] rounded-[7px] py-[3px] pr-[9px] pl-[7px] text-[11px] leading-[1.45] font-bold",
        meta.cls,
        className
      )}
    >
      <Icon className="size-3 shrink-0" strokeWidth={2} />
      {tier}
    </span>
  )
}
